import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneNumber',
    standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (!value) return '';

        const cleaned = value.replace(/\s+/g, '');

        // +31 6 31322504 => 06 31322504
        const nlMobileMatch = cleaned.match(/^\+316(\d{8})$/);
        if (nlMobileMatch) {
            return `06 ${nlMobileMatch[1]}`;
        }

        // Anders: + notatie behouden/netjes formatteren
        if (cleaned.startsWith('+')) {
            return cleaned.replace(/^(\+\d{2})(\d+)$/, '$1 $2');
        }

        return value;
    }
}
